export const globalEnvironment = {
  keyApp: 'CAZU',
  production: false,
  reCaptchaV3: {
    siteKey: '6Lc7DNwqAAAAAAfppVxTMD7_UdxuQwzSSRNWM0pc',
    language: 'es-419',
  },
};

// VARIOABLES TRANSVERSLES, SON LAS MISMAS EN LOS DOS AMBIENTE
